/**
 * Represents a Saturn transfer transaction record
 * Captures each Saturn API interaction for inventory transfers
 */
class TransferTransaction {
    constructor({
        lineItemId,
        lineItemName,
        productId,
        saturnSku,
        poQty,
        deltaSent,
        timestamp,
        saturnResponse = null,
        userId,
        success,
        error = null
    }) {
        this.lineItemId = lineItemId;
        this.lineItemName = lineItemName;
        this.productId = productId;
        this.saturnSku = saturnSku;
        this.poQty = poQty;
        this.deltaSent = deltaSent;
        this.timestamp = timestamp ? new Date(timestamp) : new Date();
        this.saturnResponse = saturnResponse;
        this.userId = userId;
        this.success = success;
        this.error = error;
    }

    /**
     * Get object representation for MongoDB storage
     * @returns {object}
     */
    getForDb() {
        return {
            lineItemId: this.lineItemId,
            lineItemName: this.lineItemName,
            productId: this.productId,
            saturnSku: this.saturnSku,
            poQty: this.poQty,
            deltaSent: this.deltaSent,
            timestamp: this.timestamp,
            saturnResponse: this.saturnResponse,
            userId: this.userId,
            success: this.success,
            error: this.error
        };
    }

    /**
     * Create a JSON representation
     * @returns {object}
     */
    toJSON() {
        return this.getForDb();
    }
}

export { TransferTransaction };
